import apiClient from '@/lib/apiClient';
import type { ApiResponse } from '@/lib/apiClient';
import { toOracleDate } from '@/lib/dateUtils';
import type { NewAccountsReportItem, PaysReportItem, ReceivedPaysReportItem } from './types';

export async function fetchNewAccountsReport(
  dateStart: string,
  dateEnd: string
): Promise<NewAccountsReportItem[]> {
  const { data } = await apiClient.get<ApiResponse<NewAccountsReportItem[]>>(
    '/api/reports/accounts/registered',
    {
      params: { date_start: toOracleDate(dateStart), date_end: toOracleDate(dateEnd) },
    }
  );
  if (!data.success) throw new Error('Ошибка загрузки отчёта');
  return data.response ?? [];
}

export async function fetchPaysReport(params: {
  date_start: string;
  date_end: string;
  id_pay_type?: string;
  dog_number?: string;
  id_statuses?: string;
}): Promise<PaysReportItem[]> {
  const { data } = await apiClient.get<ApiResponse<PaysReportItem[]>>('/api/reports/pays', {
    params: {
      ...params,
      date_start: toOracleDate(params.date_start),
      date_end: toOracleDate(params.date_end),
    },
  });
  if (!data.success) throw new Error('Ошибка загрузки отчёта');
  return data.response ?? [];
}

export async function fetchReceivedPaysReport(params: {
  date_start: string;
  date_end: string;
  id_countries?: string;
}): Promise<ReceivedPaysReportItem[]> {
  const { data } = await apiClient.get<ApiResponse<ReceivedPaysReportItem[]>>(
    '/api/reports/pays/received',
    {
      params: {
        ...params,
        date_start: toOracleDate(params.date_start),
        date_end: toOracleDate(params.date_end),
      },
    }
  );
  if (!data.success) throw new Error('Ошибка загрузки отчёта');
  return data.response ?? [];
}
